<template>
  <div>
    <!-- {{safeData}} -->
    <!-- {{safeStore.data[location]}} -->
    <h5>Safe Drops For {{ location }}</h5>
    <div style="width: 250px;">
      <BasicTableComponent 
        :list="safeData" 
        :tableID="location + '_SafeDrops'"
        :formatters="{
            'Date' : ['d', 'ddd MM/DD/YY'], 
            
            'SafeDropsCount' : ['n', '0,0'],
            'SafeDrops' : ['n', '0,0.00'],  
            
          }"
        :titles="{
          'Date' : 'Date',
          'SafeDrops' : 'Safe Drops',
          'Other' : 'Other (exceptions)',
          'SafeDropsCount' : 'Safe Drops Count',
        }" 
        :totals="totals"
        :actionNames="{
            Date: (a,b,val)=>{
              clickDate(a,b,val)
            },
          }"
      >
    </div>

    <div v-if="safeTransactions" style="width: 600px;">
      
      <h5>Safe Transactions For {{ location }}</h5>
      <BasicTableComponent 
        :list="safeTransactions" 
        :tableID="location + '_Transactions'"
        :hideColumns="['ID', 'Store_ID']"
        :formatters="{
          'DateTime' : ['d', 'ddd MM/DD/YY h:mm:ss a'],
          'Amount' : ['n', '0,0.00'],
          'Type' : ['n', '0'],
        }"
        :columnOrder="['DateTime', 'Cashier_ID', 'Override_ID', 'Amount']"
        :totals="transactionsTotals"
      />
      <p>End of transactions for {{ location }}</p>
    </div>
    
    
  </div>


</template>

<script>
import formatDataMixin from '@/mixins/formatDataMixin.js'
export default {
  
  inject: ['safeDropsPage'],
  props: ['location'],
  mixins : [formatDataMixin],
  methods:{
    clickDate(a,b,val){
      console.log('clickDate', a,b,val)
      console.log('Attempting to load data for')
      this.safeStore.loadDataForDate(this.safeData[a].Date, this.location)
    }
  },
  computed:{
    safeStore(){
      return this.safeDropsPage.$refs.safeStore
    },
    safeData(){
      return this.safeStore.data && this.safeStore.data[this.location] ? this.safeStore.data[this.location].safe : undefined;
    },
    safeTransactions(){
      return this.safeStore.data && this.safeStore.data[this.location] ? this.safeStore.data[this.location].transactions : undefined;
    },
    isLoading(){
      return this.safeStore[this.location].isLoading;
    },
    totals(){
      // if (this.isLoading)
      //   return;
      let totals = this.$math.sumKeys(this.safeData) 
      // totals = this.$util.deleteObjectProperties(totals, ['StartDateTime', 'EndDateTime', 'Start', 'End'])
      totals.Date = 'Total'
      return [totals]
    },
    transactionsTotals(){
      // if (this.isLoading)
      //   return;
      let totals = this.$math.sumKeys(this.safeTransactions) 
      // totals = this.$util.deleteObjectProperties(totals, ['StartDateTime', 'EndDateTime', 'Start', 'End'])
      totals.Date = 'Total'
      return [{DateTime: 'Total', 'Cashier_ID': `Count (${this.safeTransactions.length})`, Amount: totals.Amount}]
    },
  }
  

}
</script>

<style lang="scss" scoped>

</style>